var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleTypePedestrian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5V1.5C5 0.7 5.7 0 6.5 0C7.3 0 8 0.7 8 1.5V2.5C8 3.3 7.3 4 6.5 4C5.7 4 5 3.3 5 2.5ZM7 7L9.4 9.39999C9.8 9.79999 10.3 10 10.8 10H14V8H11L8 5H4H3.8C3.3 5 2.8 5.20001 2.4 5.60001L0.6 7.39999C0.2 7.79999 0 8.3 0 8.8V11H2V9L4 7V8.60001V11L5 12.5L4.5 14.5L0.5 18.5L2 20L6 16L6.5 14.4L11 20L12.5 18.5L7 11.7V7Z",
    fill: "#0F1621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleTypePedestrian);
export default __webpack_public_path__ + "static/media/vehicle-type-pedestrian.c205aa82951e46e43d3e26d571726b96.svg";
export { ForwardRef as ReactComponent };